"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("reactflow/dist/base.css");
var node_sidebar_1 = __importDefault(require("./node_sidebar"));
var doshx_controls_web_1 = require("doshx_controls_web");
var workflow_editor_1 = __importDefault(require("./workflow_editor"));
var react_redux_1 = require("react-redux");
var workflow_1 = require("../../../../../reducers/slices/workflow/workflow");
var react_router_dom_1 = require("react-router-dom");
var get_workflow_thunk_1 = require("../../../../../reducers/slices/workflow/thunks/get_workflow_thunk");
var console_1 = require("../../../../../reducers/slices/console");
var WorkflowPage = function () {
    var workflow_id = (0, react_router_dom_1.useParams)().workflow_id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedWorkflow = (0, react_redux_1.useSelector)(function (state) { return state.workflowState.selectedWorkflow; });
    (0, react_1.useEffect)(function () {
        if (workflow_id) {
            dispatch((0, get_workflow_thunk_1.get_workflow_thunk)(workflow_id));
        }
        else {
            dispatch((0, workflow_1.setSelectedWorkflow)({ name: "", nodes: [], edges: [] }));
            dispatch((0, console_1.setPageTitle)("New Workflow"));
        }
        return function () {
            dispatch((0, workflow_1.clearSelectedWorkflow)());
        };
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (selectedWorkflow === null || selectedWorkflow === void 0 ? void 0 : selectedWorkflow._id) {
            dispatch((0, console_1.setPageTitle)("Workflow - ".concat((_a = selectedWorkflow === null || selectedWorkflow === void 0 ? void 0 : selectedWorkflow.name) !== null && _a !== void 0 ? _a : workflow_id)));
        }
    }, [selectedWorkflow]);
    return ((0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", borderColor: "border-transparent", className: "flex flex-row max-h-svh gap-4" }, { children: [(0, jsx_runtime_1.jsx)(workflow_editor_1.default, {}), (0, jsx_runtime_1.jsx)(node_sidebar_1.default, {})] })));
};
exports.WorkflowPage = WorkflowPage;
